import { PropsWithChildren } from 'react';

import { useIsStargazer } from 'hooks/useIsStargazer';

/**
 * 별지기 전용 영역 게이트 (#2182).
 *
 * 기존 `RewardAccessGate`(크리에이터 · 성인 · KR)를 **통과한 뒤** 겹치는 두 번째 레이어다.
 * 두 게이트를 합치지 않는 이유는 실패했을 때 해야 할 일이 정반대이기 때문이다.
 * `RewardAccessGate` 는 대상자가 아닌 사람을 막는 게이트라 alert 을 띄우고 화면을 비우지만,
 * 별지기가 아닌 일반 크리에이터는 리워드 페이지를 정상적으로 쓰는 사람이라
 * 아무 말 없이 이 영역만 감춰야 한다 (정책 C — "일반 크리에이터에게 MG 문구가 없다").
 */
export default function StargazerGate({ children }: PropsWithChildren) {
  const { isStargazer, isFetched } = useIsStargazer();

  // 판별 전에는 그리지 않는다. 잠깐 노출됐다 사라지면 일반 크리에이터에게 MG 문구가 보인다.
  if (!isFetched || !isStargazer) return null;

  return <>{children}</>;
}
